import VerticalSpaceContainer from './VerticalSpaceContainer';

export default VerticalSpaceContainer;
